var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.87855 20.1964L5.23872 19.5566L5.03752 20.4388C4.70562 21.8941 4.5 23.4317 4.5 25C4.5 35.4314 12.3418 44.0398 22.4119 45.321L22.975 45.3926V44.825V40V39.5H22.475C20.0011 39.5 17.975 37.4739 17.975 35V32.5V32.2929L17.8286 32.1464L5.87855 20.1964ZM39.2489 38.6528L39.5122 39.4729L40.0938 38.8376C43.4234 35.2007 45.5 30.3319 45.5 25C45.5 16.4135 40.169 9.03459 32.6618 6.0112L31.975 5.73461V6.475V7.5C31.975 9.97386 29.9489 12 27.475 12H22.475H21.975V12.5V17.5C21.975 18.5989 21.0739 19.5 19.975 19.5H14.975H14.475V20V25V25.5H14.975H29.975C31.0739 25.5 31.975 26.4011 31.975 27.5V35V35.5H32.475H34.975C36.9948 35.5 38.6613 36.8221 39.2489 38.6528ZM0.5 25C0.5 11.4761 11.4761 0.5 25 0.5C38.5239 0.5 49.5 11.4761 49.5 25C49.5 38.5239 38.5239 49.5 25 49.5C11.4761 49.5 0.5 38.5239 0.5 25Z",
    fill: "#3B82F6",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.84b27dbb13bf4aa58bf8342cce2733f7.svg";
export { ForwardRef as ReactComponent };